import React, { useState } from "react";
import { FileDown, ImageDown, Share2, MessageCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const downloadCert = async (memberId, fmt, name) => {
  try {
    const r = await api.get(`/certificates/${memberId}/file.${fmt}`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `franchise-certificate-${(name || "member").replace(/\s+/g, "-").toLowerCase()}.${fmt}`;
    a.click();
    URL.revokeObjectURL(url);
  } catch (e) { toast.error("Download failed"); }
};

export const CertRow = ({ m, onChanged }) => {
  const [area, setArea] = useState(m.cert?.area || m.district || "");
  const [busy, setBusy] = useState("");
  const c = m.cert;
  const act = async (k, fn, msg) => { setBusy(k); try { const r = await fn(); toast.success(r?.data?.note || msg); onChanged(); } catch (e) { toast.error(apiError(e.response?.data?.detail)); } setBusy(""); };
  const id = m.id;

  return (
    <tr className="border-b border-border/30 align-top" data-testid={`cert-row-${id}`}>
      <td className="p-3"><p className="font-semibold">{m.name}</p><p className="text-xs text-emerald-100/60">BUH-{String(m.member_no || "").padStart(4, "0")} · {m.phone || "no phone"}</p></td>
      <td className="p-3 text-xs text-emerald-100/70 max-w-[260px]">{m.address || <span className="text-red-300">No address saved</span>}</td>
      <td className="p-3"><Input value={area} onChange={(e) => setArea(e.target.value)} placeholder="District / area" data-testid={`cert-area-${id}`} className="h-8 bg-card/60 min-w-[140px]" /></td>
      <td className="p-3">
        <div className="flex flex-wrap gap-1.5">
          <Button size="sm" onClick={() => act("issue", () => api.post(`/certificates/${id}`, { area }), c ? "Certificate updated" : "Certificate issued")} disabled={!!busy} data-testid={`cert-issue-${id}`} className="h-8 bg-gold text-[#0a2e22] hover:bg-gold/90">
            {busy === "issue" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : c ? "Update" : "Issue"}
          </Button>
          {c && <>
            <Button size="sm" variant="outline" onClick={() => downloadCert(id, "pdf", m.name)} data-testid={`cert-pdf-${id}`} className="h-8 gap-1"><FileDown className="w-3.5 h-3.5" /> PDF</Button>
            <Button size="sm" variant="outline" onClick={() => downloadCert(id, "png", m.name)} data-testid={`cert-png-${id}`} className="h-8 gap-1"><ImageDown className="w-3.5 h-3.5" /> Image</Button>
            <Button size="sm" variant="outline" onClick={() => act("share", () => api.post(`/certificates/${id}/share`, { on: !c.shared }), c.shared ? "Hidden from member" : "Member can now download it")} disabled={!!busy} data-testid={`cert-share-${id}`}
              className={`h-8 gap-1 ${c.shared ? "border-[#25D366] text-[#25D366]" : ""}`}><Share2 className="w-3.5 h-3.5" /> {c.shared ? "Shared" : "Share to member"}</Button>
            <Button size="sm" variant="outline" onClick={() => act("wa", () => api.post(`/certificates/${id}/whatsapp`), "Sent on WhatsApp")} disabled={!!busy || !m.phone} data-testid={`cert-wa-${id}`} className="h-8 gap-1 text-[#25D366]">
              {busy === "wa" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <MessageCircle className="w-3.5 h-3.5" />} WhatsApp
            </Button>
          </>}
        </div>
        {c && <p className="text-[10px] text-emerald-100/50 mt-1" data-testid={`cert-no-${id}`}>{c.cert_no}{c.whatsapp_sent_at ? " · sent on WhatsApp" : ""}</p>}
      </td>
    </tr>
  );
};
